import { defineStore } from "pinia";

export function createSelectedItemStore<T>(id: string) {
	return defineStore(id, {
		state: () => {
			return {
				selected: null as T | null,
			};
		},
		actions: {
			set(item: T | null) {
				this.selected = item;
			},
		},
	})();
}

export function useSelectedItemStore<T>(id: string): ISelectedItemStore<T> {
	return defineStore(id, {
		state: () => { throw Error(`store ${id} must be created with defineSelectedItemStore() before it can be used`); },
	})();
}

export type ISelectedItemStoreDefinition<T> = ReturnType<typeof createSelectedItemStore<T>>;
export type ISelectedItemStore<T> = ReturnType<ISelectedItemStoreDefinition<T>>;
